export default {
      id: "btn-info-usage",
      viewBox: "0 0 70 90",
      url: __webpack_public_path__ + "img/icons.50d286a4.svg#btn-info",
      toString: function () {
        return this.url;
      }
    }